'use client';

import { BlogHomePage, type CategorySection } from '@/components/pages/blog/BlogHomePage';
import { useAppNavigate } from './_lib/useAppNavigate';
import type { BlogPostDocument } from '@/firebase/blog-db';

interface BlogHomeClientProps {
  initialFeatured: BlogPostDocument | null;
  initialSections: CategorySection[];
}

export default function BlogHomeClient({ initialFeatured, initialSections }: BlogHomeClientProps) {
  const navigate = useAppNavigate();
  return <BlogHomePage onNavigate={navigate} featured={initialFeatured} sections={initialSections} />;
}
